import { f as r } from "./atoms-v21255.js";
import { _ as e } from "./atoms-v21256.js";
import { _ as o } from "./atoms-v21257.js";
var a = r, s = e, f = o;
function n(t) {
  return f(s(t, void 0, a), t + "");
}
var l = n;
export {
  l as _
};
